// Gemeinsame Typen der Serienmail-Regeln. Bewusst ohne Supabase-Bezug, damit die Regeln
// ohne Datenbank getestet werden koennen — die Ladefunktionen in api.ts fuellen sie.

// #577: dazu Dienstleister und sonstige Kontakte (Tabelle `kontakte`, owner_type 'kontakt').
export type Zielgruppe = 'mieter' | 'eigentuemer' | 'dienstleister' | 'kontakt';
export const ZIELGRUPPEN: readonly Zielgruppe[] = ['mieter', 'eigentuemer', 'dienstleister', 'kontakt'];

/** Ein moeglicher Empfaenger, bevor entschieden ist, ob er erreichbar ist. */
export interface Kandidat {
  owner_type: Zielgruppe;
  owner_id: string;
  name: string;
  /** null = keine Adresse hinterlegt; solche Kandidaten werden nie angeschrieben. */
  email: string | null;
  objekt_id: string | null;
  objekt_bezeichnung: string;
  einheit_id: string | null;
  /** Bezeichnung der Einheit (z. B. „WE 04"); leer bei Eigentuemern. */
  einheit_bezeichnung: string;
  strasse: string;
  hausnummer: string;
  plz: string;
  stadt: string;
  /** Für die Briefanrede („Sehr geehrte Frau Berg,“) – fehlt bei Firmen/Dienstleistern. */
  anrede?: string | null;
  nachname?: string | null;
}

/** Zeile aus kontakt_kanaele, auf das Noetige reduziert. */
export interface KanalZeile {
  owner_id: string;
  kanal: string;
  wert: string;
  ist_primaer: boolean;
  sortierung: number;
}

/**
 * #579: sammelt die IDs (`typ:id`) der wegen „nicht aktiv“ ausgeblendeten Kontakte, damit der
 * Empfänger-Schritt sagen kann, wie viele es waren. Wer über ein anderes, aktives Objekt doch
 * dabei ist, zählt am Ende nicht als ausgeblendet (siehe zaehleAusgeblendet).
 */
export type Ausgeblendet = Set<string>;

export interface Filter {
  /** #577: true = alle Kontakte der Gruppe, ohne Objektbezug (objektIds/einheitIds egal). */
  alle?: boolean;
  objektIds: string[];
  /** Leer oder fehlend = alle Einheiten der gewaehlten Objekte. */
  einheitIds?: string[];
}

/**
 * Ein Mieter, wie ihn die Datenbank hergibt. Die Tabelle `mieter` fuehrt KEINE
 * Anschrift — die Postadresse eines Mieters ist die des Objekts, in dem er wohnt.
 * Deshalb kommen die Adressfelder hier mit dem Praefix `objekt_` aus dem Embed.
 */
export interface MieterRoh {
  id: string;
  vorname: string | null;
  nachname: string | null;
  email: string | null;
  status: string | null;
  objekt_id: string | null;
  einheit_id: string | null;
  objekt_bezeichnung: string | null;
  objekt_strasse: string | null;
  objekt_hausnummer: string | null;
  objekt_plz: string | null;
  objekt_stadt: string | null;
  einheit_bezeichnung: string | null;
  /** #579: Mietende (YYYY-MM-DD) – liegt es in der Vergangenheit, ist der Mieter ausgezogen. */
  mietende?: string | null;
  /** #579: Status des Objekts – „Archiviert“ = nicht mehr verwaltet. */
  objekt_status?: string | null;
  anrede?: string | null;
}

export interface EigentuemerRoh {
  id: string;
  anrede: string | null;
  firma_name: string | null;
  vorname: string | null;
  nachname: string | null;
  email: string | null;
  strasse: string | null;
  hausnummer: string | null;
  plz: string | null;
  /** Die Spalte heisst in der Datenbank `stadt`, nicht `ort`. */
  stadt: string | null;
  objekt_id: string;
  objekt_bezeichnung: string | null;
  /** #579: Status des Eigentümers („aktiv“/„inaktiv“, Groß-/Kleinschreibung gemischt). */
  status?: string | null;
  /** #579: Verwaltervertrag beendet (eigentuemer.vertragsende bzw. objekt_eigentuemer.vertrag_bis). */
  vertragsende?: string | null;
  vertrag_bis?: string | null;
  objekt_status?: string | null;
}

/** #577: Dienstleister – global aus `dienstleister`, je Objekt über `dienstleister_objekt`. */
export interface DienstleisterRoh {
  id: string;
  name: string | null;
  email: string | null;
  aktiv: boolean | null;
  strasse: string | null;
  hausnummer: string | null;
  plz: string | null;
  stadt: string | null;
  /** null bei globaler Auswahl */
  objekt_id: string | null;
  objekt_bezeichnung: string | null;
  /** #579: Zuordnung zum Objekt endet/endete (dienstleister_objekt.bis). */
  bis?: string | null;
  objekt_status?: string | null;
}

/** #577: sonstige Kontakte – global aus `kontakte`, je Objekt über `objekt_kontakte`. */
export interface KontaktRoh {
  id: string;
  anrede: string | null;
  firma_name: string | null;
  vorname: string | null;
  nachname: string | null;
  email: string | null;
  status: string | null;
  strasse: string | null;
  hausnummer: string | null;
  plz: string | null;
  stadt: string | null;
  objekt_id: string | null;
  objekt_bezeichnung: string | null;
  objekt_status?: string | null;
}
